import { render, staticRenderFns } from "./AboutESGMain.vue?vue&type=template&id=3a793ca4&scoped=true&"
import script from "./AboutESGMain.vue?vue&type=script&lang=js&"
export * from "./AboutESGMain.vue?vue&type=script&lang=js&"
import style0 from "./AboutESGMain.vue?vue&type=style&index=0&id=3a793ca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a793ca4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a793ca4')) {
      api.createRecord('3a793ca4', component.options)
    } else {
      api.reload('3a793ca4', component.options)
    }
    module.hot.accept("./AboutESGMain.vue?vue&type=template&id=3a793ca4&scoped=true&", function () {
      api.rerender('3a793ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/AboutESG/AboutESGMain.vue"
export default component.exports